const {Component} = require("react");
const {computed} = require("mobx");
const {observer} = require("mobx-react");
const store = require("stores/CartStore");
const {classList} = require("helpers/html");
const {decodeObservable} = require("helpers/object");
const moment = require("moment");
const {moneyFormat} = require("helpers/format");
const $ = require("helpers/element");
const PropTypes = require("prop-types");
const router = require("services/router");
const Stars = require("components/mixins/Stars");

@observer
class Cart extends Component {

	static get propTypes() {
		return {
			defaultAvatarUrl: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			defaultAvatarUrl: "img/avatar-placeholder.png"
		}
	}

	constructor(props) {
		super(props);

		this.state = {
			open: false,
			selectedDay: null,
			loadingDays: [],
			loadingSlots: []
		};
	}

	@computed
	get cart() {
		return decodeObservable(store.attributes);
	}

	@computed
	get bookable() {
		return this.cart.bookable;
	}

	@computed
	get bookings() {
		return this.cart.bookings;
	}

	@computed
	get allInstant() {
		const bookings = this.bookings;
		for (let i = 0; i < bookings.length; i++) {
			if (!bookings[i].instant) {
				return false;
			}
		}

		return true;
	}

	get submitLabel() {
		return this.allInstant ? "Book nu" : "Send forespørgsel";
	}

	@computed
	get bookingDays() {
		return this.bookings.reduce((acc, booking) => {
			const date = moment(booking.from).format("YYYY-MM-DD");

			if (acc.indexOf(date) === -1) {
				acc.push(date);
			}

			return acc;
		}, []).sort();
	}

	@computed
	get bookingsOnSelectedDay() {
		if (this.state.selectedDay == undefined) {
			return [];
		}

		return this.bookings
			.filter(booking => {
				return moment(booking.from).format("YYYY-MM-DD") === this.state.selectedDay;
			})
			.sort((bookingA, bookingB) => {
				return moment(bookingA.from).isBefore(moment(bookingB.from)) ? -1 : 1;
			});
	}

	get className() {
		const length = this.bookings.length;

		return classList(
			"cart",
			this.state.open ? "open" : null,
			length === 0 ? "cart-empty" : null,
			(length === 1) || (length === 2) ? "cart-small" : null,
			(length > 2) && (length <= 3) ? "cart-medium" : null,
			length > 3 ? "cart-large" : null
		);
	}

	render() {
		return (
			<div className={this.className}>
				{this.renderBar()}
				{this.renderBody()}
			</div>
		);
	}

	/////////////////////////////////
	// Listeners & actions
	/////////////////////////////////

	handleSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();

		window.location = router.route("checkout.activate", {
			guid: this.cart.guid
		});
	};

	handleBookingRemoveOnBody = () => {
		// select another day if the current one doesn't exists anymore
		const days = this.bookingDays;

		if (days.indexOf(this.state.selectedDay) === -1) {
			this.setState({selectedDay: days.length > 0 ? days[0] : null});
		}

		// close if no bookings left
		if (this.bookings.length === 0) {
			this.closeBody();
		}
	};

	setDayLoadingState(day, loading = true) {
		const index = this.state.loadingDays.indexOf(day);

		if (loading) {
			if (index === -1) {
				this.setState(state => {
					state.loadingDays.push(day);
					return state;
				});
			}
		}
		else {
			if (index !== -1) {
				this.setState(state => {
					state.loadingDays.splice(index, 1);
					return state;
				});
			}
		}
	}

	setSlotLoadingState(date, loading = true) {
		const index = this.state.loadingSlots.indexOf(date);

		if (loading) {
			if (index === -1) {
				this.setState(state => {
					state.loadingSlots.push(date);
					return state;
				});
			}
		}
		else {
			if (index !== -1) {
				this.setState(state => {
					state.loadingSlots.splice(index, 1);
					return state;
				});
			}
		}
	}

	removeBookingListener(booking) {
		return (e) => {
			e.preventDefault();
			e.stopPropagation();

			this.setSlotLoadingState(booking.from, true);
			store.remove(booking.id).then(() => {
				this.setSlotLoadingState(booking.from, false);
				this.handleBookingRemoveOnBody();
			});
		};
	}

	removeBookingDayListener(day) {
		return (e) => {
			e.preventDefault();
			e.stopPropagation();

			const booking_ids = this.bookings
				.filter(booking => moment(booking.from).format("YYYY-MM-DD") === day)
				.map(booking => booking.id);

			this.setDayLoadingState(day, true);

			store.remove(booking_ids).then(() => {
				this.setDayLoadingState(day, false);
				this.handleBookingRemoveOnBody();
			});
		};
	}

	changeSelectedDayListener(day) {
		return (e) => {
			e.preventDefault();
			e.stopPropagation();

			this.setState({selectedDay: day});
		};
	}

	closeBody() {
		this.setState({open: false, selectedDay: null}, () => {
			$(document.body).setClass("open-booking", this.state.open);
		});
	}

	openBody() {
		const days = this.bookingDays;
		this.setState({open: true, selectedDay: days.length > 0 ? days[0] : null}, () => {
			$(document.body).setClass("open-booking", this.state.open);
		});
	}

	toggleBodyOpen = (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.state.open ? this.closeBody() : this.openBody();
	};

	/////////////////////////////////
	// Cart book bar
	/////////////////////////////////

	renderBarSelection() {
		const bookings = this.bookings;

		const selectionMarkup = bookings.map(booking => {
			const from = moment(booking.from);
			const to = moment(booking.to);

			return (
				<div key={booking.id} className="time-tag" onClick={this.removeBookingListener(booking)}>
					{from.format("ddd DD. MMM")} / {from.format("HH:mm")} - {to.format("HH:mm")}
				</div>
			);
		});

		const plural = bookings.length > 1;
		const word = plural ?
			'tidspunkter' :
			'tidspunkt';

		return (
			<div className="selected-times">
				<p><span>{bookings.length}</span> {word} valgt</p>
				{selectionMarkup}
			</div>
		);
	}

	renderBarPrice() {
		const total = (this.cart.unit_price || 0.0) * this.bookings.length;

		return (
			<div className="price-box">
				<div className="price">
					<span className="price-label">Totalpris: </span>
					<span className="price-value">{moneyFormat(total, {currency: false})}</span>
					<span className="price-currency">DKK</span>
					<span className="price-moms">Inkl. moms</span>
				</div>
			</div>
		);
	}

	renderBarBookable() {
		const bookable = this.bookable;
		const unitPrice = this.cart.unit_price || 0.0;
		const avatarUrl = bookable.avatar ? bookable.avatar.url : router.url(this.props.defaultAvatarUrl);
		const ratingMarkup = bookable.averrage_rating ?
			(<Stars filled={bookable.averrage_rating}/>) : null;

		return (
			<div className="bookable-info">
				<img src={avatarUrl} alt={bookable.name}/>
				<div className="bookable-personal">
					<span>{bookable.nickname}</span>
					{ratingMarkup}
				</div>
				<div className="bookable-booking">
					<span className="bookable-booking-pricing">
						<span>{moneyFormat(unitPrice, {currency: false})}</span>
						DKK PR. TIME
					</span>
					<span className="bookable-booking-ref-distance"></span>
				</div>
			</div>
		);
	}

	renderBar() {
		return (
			<div className="book-bar">
				<div className="book-bar-inner container">
					<button type="button" className="open-btn" onClick={this.toggleBodyOpen}></button>
					{this.renderBarSelection()}
					{this.renderBarPrice()}
					{this.renderBarBookable()}
					<button disabled={this.bookings.length === 0} className="btn to-checkout" onClick={this.handleSubmit}>
						{this.submitLabel}
					</button>
				</div>
			</div>
		);
	}

	/////////////////////////////////
	// Cart book body
	/////////////////////////////////

	renderBodyList() {
		return this.bookingDays.map(day => {
			const date = moment(day);
			const className = classList(
				"list-item",
				day === this.state.selectedDay ? "active" : null,
				this.state.loadingDays.indexOf(day) !== -1 ? "loading" : null
			);

			return (
				<div key={day} className={className}>
					<img src={router.url("img/icons/calender-settings.svg")} alt="Time"/>
					<p onClick={this.changeSelectedDayListener(day)}>{date.format("dddd [d.] DD MMMM YYYY")}</p>
					<button type="button" className="remove" onClick={this.removeBookingDayListener(day)}>
						<img src={router.url("img/icons/close-small-grey.svg")} alt="Remove"/>
						<svg className="circle-loader" width="40" height="40" version="1.1" xmlns="http://www.w3.org/2000/svg">
							<circle cx="20" cy="20" r="8"/>
						</svg>
					</button>
				</div>
			);
		});
	}

	renderBodyBookings() {
		return this.bookingsOnSelectedDay.map(booking => {
			const from = moment(booking.from);
			const to = moment(booking.to);
			const className = classList(
				"available-time", "selected",
				this.state.loadingSlots.indexOf(booking.from) !== -1 ? "loading" : null
			);

			return (
				<div key={booking.id} className={className} onClick={this.removeBookingListener(booking)}>
					<div className="available-time-content">
						<p className="time">{from.format("HH:mm")} - {to.format("HH:mm")}</p>
						<p className="date">{from.format("ddd. DD MMMM")}</p>
					</div>
				</div>
			);
		});
	}

	renderBody() {
		const selectedDay = this.state.selectedDay ?
			moment(this.state.selectedDay).format("ddd DD. MMMM YYYY") :
			null;

		return (
			<div id="booking" className="booking">
				<div className="booking-container container">
					<div className="booking-inner">

						<div className="booking-col">
							<div className="sub-title-bar">Valgte tider</div>
							<h2>Dine bookinger</h2>
							<div className="list">{this.renderBodyList()}</div>

							{/*
							<div className="sub-title-bar">Information</div>

							<p>Information text her</p>
							*/}

						</div>

						<div className="booking-col">
							<p className="cur-date">{selectedDay}</p>
							<div className="all-times">{this.renderBodyBookings()}</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

}

module.exports = Cart;



// WEBPACK FOOTER //
// ./resources/js/components/checkout/Cart.js